import { z } from "zod";
import { defineEndpoint } from "./endpoint.js";
/** The audit log (docs/specs/audit.md). Read-only: there is no way to change an entry. */
export const auditActorTypeSchema = z.enum(["user", "system", "device", "platform"]);
export const auditLogEntrySchema = z.object({
    id: z.uuid(),
    occurredAt: z.iso.datetime(),
    actorType: auditActorTypeSchema,
    actorId: z.uuid().nullable(),
    action: z.string(),
    entity: z.string(),
    entityId: z.uuid().nullable(),
    locationId: z.uuid().nullable(),
    before: z.unknown().nullable(),
    after: z.unknown().nullable(),
    requestId: z.string().nullable(),
    ip: z.string().nullable(),
    userAgent: z.string().nullable(),
    deviceId: z.uuid().nullable(),
});
export const auditLogListSchema = z.object({
    data: z.array(auditLogEntrySchema),
    nextCursor: z.uuid().nullable(),
});
/** `GET /v1/audit-logs`: newest first. `from`/`to` are ISO-8601 instants (inclusive / exclusive). */
export const auditLogQuerySchema = z.object({
    actorId: z.uuid().optional(),
    entity: z.string().min(1).max(64).optional(),
    entityId: z.uuid().optional(),
    action: z.string().min(1).max(128).optional(),
    from: z.iso.datetime({ offset: true }).optional(),
    to: z.iso.datetime({ offset: true }).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.uuid().optional(),
});
export const listAuditLogs = defineEndpoint({
    name: "listAuditLogs",
    method: "GET",
    path: "/v1/audit-logs",
    access: { permission: "audit.view" },
    summary: "The audit log, newest first (branch viewers see their locations only)",
    tag: "audit",
    query: auditLogQuerySchema,
    status: 200,
    response: auditLogListSchema,
});
//# sourceMappingURL=audit.js.map